// Remove the single-hop ?currency= control param once Shopify has consumed it
// server-side, so it never enters shared/bookmarked URLs, paginate/filter links,
// or the search UI's history writes. Shopify sets cart_currency on this load, so
// refreshing the stripped URL keeps the currency.
(function () {
    try {
        if (!(window.history && window.history.replaceState && window.URL)) return;
        var mdvStripUrl = new URL(window.location.href);
        if (!mdvStripUrl.searchParams.has('currency')) return;
        mdvStripUrl.searchParams.delete('currency');
        window.history.replaceState(window.history.state, document.title,
            mdvStripUrl.pathname + mdvStripUrl.search + mdvStripUrl.hash);
    } catch (mdvStripError) {}
})();


function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
}
function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}
function eraseCookie(key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, '-1');
}

const countryOffers = [
    {
        countryCodes: ["GB"],
        offers: [
            "- Free Delivery Over £150",
            "- £2.99 Fixed-Fee UK Postal Returns",
            "- Free In-Store Returns"
        ]
    },
    {
        countryCodes: ["EU","BG","HR","CY","CZ","DK","EE","FI","GR","HU","IE","IT","LV","LT","MT","PL","PT","RO","SK","SI","ES","SE","AT","FR","LU","DE","BE"],
        offers: [
            "- Shipped Locally from Europe",
            "- Free Delivery Over €200",
            "- Express Delivery - Guaranteed delivery within 2 days / €10",
            "- Fixed-Fee Returns from €8"
        ]
    },
    {
        countryCodes: ["NL"],
        offers: [
            "- Shipped from the Netherlands",
            "- Free Delivery Over €200",
            "- Next Day Delivery / €12",
            "- Fixed-Fee Returns from €8"
        ]
    },
    {
        countryCodes: ["CA"],
        offers: [
            "- Free Delivery Over 300 CAD",
            "- Express Delivery - Guaranteed delivery within 6 days",
            "- Import Fees Included at Checkout"
        ]
    },
    {
        countryCodes: ["US"], 
        offers: [
            "- Shipped Locally from U.S.",
            "- No Tariff Charges",
            "- Express Delivery - Guaranteed delivery within 2 days",
            "- Standard Delivery - Guaranteed delivery within 5 days",
            "- Free Delivery Over $250"
        ]
    },
    {
        countryCodes: ["AE"], 
        offers: [
            "- Free Next Day Delivery",
            "- Free Same-Day Delivery Over 400 AED",
            "- Easy Online Returns"
        ]
    },
    {
        countryCodes: ["KW"], 
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 5 days."
        ]
    },
    {
        countryCodes: ["SA"],
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 8 days."
        ]
    },
    {
        countryCodes: ["CH"],
        offers: [
            "- Free Delivery Over CHF 175"
        ]
    },
    {
        countryCodes: ["NO"],
        offers: [
            "- Free Delivery Over £150",
            "- Tracked International Delivery"
        ]
    },
    {
        countryCodes: ["ME","DZ","AR","BN","BO","BF","KH","CL","GQ","KE","MV","NZ","PK","PE","PY","PA","LK","SC","SN","TN","VN","VE","ZM","ZW","AL","AD","BD","BT","GL","IS","LA","LY","LI","MC","NP","MK","PS","ROW","RS","VA","GI","AM","AZ","BA","BR","CN","CO","DO","EG","GE","GH","HK","IN","ID","IL","IQ","JP","JO","KZ","LB","MY","MA","MX","MD","NG","PH","SG","ZA","KR","TW","TH","TR"],
        offers: [
            "- Tracked International Delivery"
        ]
    },
    {
        countryCodes: ["QA","OM","BH"],
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 5 days."
        ]
    },
    {
        countryCodes: ["AU"],
        offers: [
            "- Free delivery over 400 AUD",
            "- Express Delivery - Guaranteed delivery within 4 days"
        ]
    }
];
const countriesLanguages = [
  {
    "country_code": "NL",
    "country_name": "Netherlands",
    "languages": [
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "FR",
    "country_name": "France",
    "languages": [
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "LU,BE",
    "country_name": "Luxembourg, Belgium",
    "languages": [
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "SA,QA,KW",
    "country_name": "Saudi Arabia, Qatar, Kuwait",
    "languages": [
      { "name": "Arabic", "code": "gl_language=ar-AE" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "AE",
    "country_name": "United Arab Emirates",
    "languages": [
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Arabic", "code": "gl_language=ar-AE" }
    ]
  },
  {
    "country_code": "AT,DE",
    "country_name": "Austria, Germany",
    "languages": [
      { "name": "German", "code": "gl_language=de-DE" },
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" }
    ]
  },
  {
    "country_code": "ES",
    "country_name": "Spain",
    "languages": [
      { "name": "Spanish", "code": "gl_language=es-ES" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "IT",
    "country_name": "Italy",
    "languages": [
      { "name": "Italian", "code": "gl_language=it-IT" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "PT",
    "country_name": "Portugal",
    "languages": [
      { "name": "Portuguese", "code": "gl_language=pt-PT" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "SE",
    "country_name": "Sweden",
    "languages": [
      { "name": "Swedish", "code": "gl_language=sv-SE" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "DK",
    "country_name": "Denmark",
    "languages": [
      { "name": "Danish", "code": "gl_language=da-DK" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "NO",
    "country_name": "Norway",
    "languages": [
      { "name": "Norwegian", "code": "gl_language=nb-NO" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "FI",
    "country_name": "Finland",
    "languages": [
      { "name": "Finnish", "code": "gl_language=fi-FI" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "PL",
    "country_name": "Poland",
    "languages": [
      { "name": "Polish", "code": "gl_language=pl-PL" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "GR",
    "country_name": "Greece",
    "languages": [
      { "name": "Greek", "code": "gl_language=el-GR" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "RO",
    "country_name": "Romania",
    "languages": [
      { "name": "Romanian", "code": "gl_language=ro-RO" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  }
];
const countryCurrencyArray = [
  { "US": { "currency": "USD", "country": "United States of America" } },
  { "GB": { "currency": "GBP", "country": "United Kingdom" } },
  { "DE": { "currency": "EUR", "country": "Germany" } },
  { "NL": { "currency": "EUR", "country": "Netherlands" } },
  { "FR": { "currency": "EUR", "country": "France" } },
  { "CA": { "currency": "CAD", "country": "Canada" } },
  { "AU": { "currency": "AUD", "country": "Australia" } },
  { "AL": { "currency": "ALL", "country": "Albania" } },
  { "DZ": { "currency": "DZD", "country": "Algeria" } },
  { "AD": { "currency": "EUR", "country": "Andorra" } },
  { "AM": { "currency": "AMD", "country": "Armenia" } },
  { "AT": { "currency": "EUR", "country": "Austria" } },
  { "AZ": { "currency": "AZN", "country": "Azerbaijan" } },
  { "AR": { "currency": "AED", "country": "Argentina" } },
  { "BH": { "currency": "AED", "country": "Bahrain" } },
  { "BD": { "currency": "BDT", "country": "Bangladesh" } },
  { "BE": { "currency": "EUR", "country": "Belgium" } },
  { "BT": { "currency": "AED", "country": "Bhutan" } },
  { "BA": { "currency": "BAM", "country": "Bosnia and Herzegovina" } },
  { "BR": { "currency": "AED", "country": "Brazil" } },
  { "BN": { "currency": "BND", "country": "Brunei" } },
  { "BG": { "currency": "EUR", "country": "Bulgaria" } },
  { "BO": { "currency": "BOB", "country": "Bolivia" } },
  { "BF": { "currency": "AED", "country": "Burkina Faso" } },
  { "KH": { "currency": "KHR", "country": "Cambodia" } },
  { "CN": { "currency": "CNY", "country": "China" } },
  { "CO": { "currency": "AED", "country": "Colombia" } },
  { "HR": { "currency": "EUR", "country": "Croatia" } },
  { "CY": { "currency": "EUR", "country": "Cyprus" } },
  { "CZ": { "currency": "EUR", "country": "Czechia" } },
  { "CL": { "currency": "AED", "country": "Chile" } },
  { "DK": { "currency": "DKK", "country": "Denmark" } },
  { "DO": { "currency": "DOP", "country": "Dominican Republic" } },
  { "EE": { "currency": "EUR", "country": "Estonia" } },
  { "EG": { "currency": "EGP", "country": "Egypt" } },
  { "GQ": { "currency": "AED", "country": "Equatorial Guinea" } },
  { "FI": { "currency": "EUR", "country": "Finland" } },
  { "GE": { "currency": "AED", "country": "Georgia" } },
  { "GI": { "currency": "GBP", "country": "Gibraltar" } },
  { "GR": { "currency": "EUR", "country": "Greece" } },
  { "GL": { "currency": "DKK", "country": "Greenland" } },
  { "GH": { "currency": "AED", "country": "Ghana" } },
  { "HK": { "currency": "HKD", "country": "Hong Kong" } },
  { "HU": { "currency": "EUR", "country": "Hungary" } },
  { "IS": { "currency": "ISK", "country": "Iceland" } },
  { "IN": { "currency": "INR", "country": "India" } },
  { "ID": { "currency": "IDR", "country": "Indonesia" } },
  { "IE": { "currency": "EUR", "country": "Ireland" } },
  { "IL": { "currency": "ILS", "country": "Israel" } },
  { "IT": { "currency": "EUR", "country": "Italy" } },
  { "IQ": { "currency": "AED", "country": "Iraq" } },
  { "JP": { "currency": "JPY", "country": "Japan" } },
  { "JO": { "currency": "AED", "country": "Jordan" } },
  { "KW": { "currency": "USD", "country": "Kuwait" } },
  { "KZ": { "currency": "KZT", "country": "Kazakhstan" } },
  { "KE": { "currency": "KES", "country": "Kenya" } },
  { "LA": { "currency": "LAK", "country": "Laos" } },
  { "LV": { "currency": "EUR", "country": "Latvia" } },
  { "LB": { "currency": "LBP", "country": "Lebanon" } },
  { "LY": { "currency": "GBP", "country": "Libya" } },
  { "LI": { "currency": "CHF", "country": "Liechtenstein" } },
  { "LT": { "currency": "EUR", "country": "Lithuania" } },
  { "LU": { "currency": "EUR", "country": "Luxembourg" } },
  { "MY": { "currency": "MYR", "country": "Malaysia" } },
  { "MT": { "currency": "EUR", "country": "Malta" } },
  { "MC": { "currency": "EUR", "country": "Monaco" } },
  { "MA": { "currency": "MAD", "country": "Morocco" } },
  { "MX": { "currency": "MXN", "country": "Mexico" } },
  { "MD": { "currency": "MDL", "country": "Moldova" } },
  { "MV": { "currency": "MVR", "country": "Maldives" } },
  { "NP": { "currency": "NPR", "country": "Nepal" } },
  { "NZ": { "currency": "NZD", "country": "New Zealand" } },
  { "MK": { "currency": "MKD", "country": "North Macedonia" } },
  { "NO": { "currency": "NOK", "country": "Norway" } },
  { "NG": { "currency": "NGN", "country": "Nigeria" } },
  { "OM": { "currency": "AED", "country": "Oman" } },
  { "PK": { "currency": "PKR", "country": "Pakistan" } },
  { "PS": { "currency": "ILS", "country": "Palestinian Territories" } },
  { "PH": { "currency": "PHP", "country": "Philippines" } },
  { "PL": { "currency": "EUR", "country": "Poland" } },
  { "PT": { "currency": "EUR", "country": "Portugal" } },
  { "PE": { "currency": "PEN", "country": "Peru" } },
  { "PY": { "currency": "PYG", "country": "Paraguay" } },
  { "PA": { "currency": "AED", "country": "Panama" } },
  { "QA": { "currency": "QAR", "country": "Qatar" } },
  { "ROW": { "currency": "GBP", "country": "Rest of the World" } },
  { "RO": { "currency": "EUR", "country": "Romania" } },
  { "SA": { "currency": "SAR", "country": "Saudi Arabia" } },
  { "RS": { "currency": "RSD", "country": "Serbia" } },
  { "SG": { "currency": "SGD", "country": "Singapore" } },
  { "SK": { "currency": "EUR", "country": "Slovakia" } },
  { "SI": { "currency": "EUR", "country": "Slovenia" } },
  { "ZA": { "currency": "AED", "country": "South Africa" } },
  { "ES": { "currency": "EUR", "country": "Spain" } },
  { "LK": { "currency": "LKR", "country": "Sri Lanka" } },
  { "SE": { "currency": "EUR", "country": "Sweden" } },
  { "CH": { "currency": "CHF", "country": "Switzerland" } },
  { "KR": { "currency": "KRW", "country": "South Korea" } },
  { "SC": { "currency": "AED", "country": "Seychelles" } },
  { "SN": { "currency": "AED", "country": "Senegal" } },
  { "TW": { "currency": "TWD", "country": "Taiwan" } },
  { "TH": { "currency": "THB", "country": "Thailand" } },
  { "TN": { "currency": "AED", "country": "Tunisia" } },
  { "TR": { "currency": "AED", "country": "Turkey" } },
  { "AE": { "currency": "AED", "country": "United Arab Emirates" } },
  { "VA": { "currency": "EUR", "country": "Vatican City" } },
  { "VN": { "currency": "VND", "country": "Vietnam" } },
  { "VE": { "currency": "AED", "country": "Venezuela" } },
  { "ZM": { "currency": "AED", "country": "Zambia" } },
  { "ZW": { "currency": "AED", "country": "Zimbabwe" } }
];  

// The selectedCountry cookie is domain-wide (.manieredevoir.com), so a country
// chosen on one regional store is still readable on all the others. The redirect
// logic wants that raw cross-store value, but anything DISPLAYING this store's
// own context must not trust it -- otherwise a UAE choice renders a UAE flag and
// UAE delivery copy on the US store. Returns the country only when this store
// actually serves it, else null.
//
// A store answers on several hosts (ME also on ae./sa./kw./qa., EU on
// fr./de./es..., UK on no.), so origin alone would wrongly reject its own
// countries. data-currency is the market code shared by every host of one store.
window.mdvSelectedCountryForThisStore = function mdvSelectedCountryForThisStore() {
  const raw = document.cookie
    .split('; ')
    .find(c => c.startsWith('selectedCountry='))
    ?.split('=')[1];
  if (!raw || !/^[A-Z]{2,3}$/.test(raw)) return null;
  const scope = '.country-selector-select .country-selector-option li';
  const opt = document.querySelector(scope + '[data-code="' + raw + '"]');
  if (!opt) return null;
  const here = document.querySelector(scope + '[data-href="' + location.origin + '"]');
  const market = here && here.getAttribute('data-currency');
  if (opt.getAttribute('data-href') === location.origin
    || (market && opt.getAttribute('data-currency') === market)) return raw;
  return null;
};

function updateCountryFlag() {

 const countryFlags = {
   'AE': 'https://cdn.shopify.com/s/files/1/0282/6678/files/UAE.webp?v=1734340288',
   'QA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Qatar.webp?v=1734340288',
   'SA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Saudi_Arabia.webp?v=1734340288',
   'KW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kuwait.webp?v=1734340288',
   'AU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/ef8d72c4-fdf0-11ec-8b88-5254005a3760.png?v=1657253778',
   'IL' : 'https://cdn.shopify.com/s/files/1/0630/4261/7558/files/israel-29-12-2025.png?v=1767011031',
   'DE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Germany.png?v=1767591709',
   'NL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Netherlands.png?v=1767591743',
   'FR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/France.png?v=1767591743',
   'AL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Albania.png?v=1767591744',
   'DZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Algeria.png?v=1767591744',
   'AD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Andorra.png?v=1767591744',
   'AM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Armenia.png?v=1767591742',
   'AT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Austria.png?v=1767591743',
   'AZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Azerbaijan.png?v=1767591745',
   'AR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Argentina.png?v=1767597201',
   'BH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bahrain.png?v=1767591743',
   'BD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bangladesh.png?v=1767591744',
   'BE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Belgium.png?v=1767591743',
   'BT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bhutan.png?v=1767591744',
   'BA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bosnia_and_Herzegovina.png?v=1767591743',
   'BR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Brazil.png?v=1767591744',
   'BN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Brunei.png?v=1767591744',
   'BG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bulgaria.png?v=1767591743',
   'BO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bolivia.png?v=1767591744',
   'BF' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Burkina_Faso.png?v=1767597201',
   'KH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Cambodia.png?v=1767591744',
   'CN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/China.png?v=1767591744',
   'CO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Colombia.png?v=1767591743',
   'HR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Croatia.png?v=1767591743',
   'CY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Cyprus.png?v=1767591743',
   'CZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Czechia.png?v=1767591743',
   'CL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Chile.png?v=1767591743',
   'DK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Denmark.png?v=1767591743',
   'DO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Dominican_Republic.png?v=1767591744',
   'EE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Estonia.png?v=1767597201',
   'EG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Egypt.png?v=1767591744',
   'GQ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Equatorial_Guinea.png?v=1767591744',
   'FI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Finland.png?v=1767591742',
   'GE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Georgia.png?v=1767591743',
   'GI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Gibraltar.png?v=1767591744',
   'GR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Greece.png?v=1767591742',
   'GL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Greenland.png?v=1767591743',
   'GH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Ghana.png?v=1767591743',
   'HK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Hong_Kong.png?v=1767591743',
   'HU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Hungary.png?v=1767597201',
   'IS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Iceland.png?v=1767591743',
   'IN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/India.png?v=1767591744',
   'ID' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Indonesia.png?v=1767591743',
   'IE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Ireland.png?v=1767591744',
   'IT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Italy.png?v=1767591743',
   'IQ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Iraq.png?v=1767591744',
   'JP' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Japan.png?v=1767591743',
   'JO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Jordan.png?v=1767591743',
   'KZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kazakhstan.png?v=1767591744',
   'LV' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Latvia.png?v=1767591743',
   'KE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kenya.png?v=1767591744',
   'LA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Laos.png?v=1767591744',
   'LB' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Lebanon.png?v=1767591743',
   'LY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Libya.png?v=1767591744',
   'LI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Liechtenstein.png?v=1767591743',
   'LT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Lithuania.png?v=1767591744',
   'LU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Luxembourg.png?v=1767594349',
   'MY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Malaysia.png?v=1767597201',
   'MT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Malta.png?v=1767594350',
   'MC' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Monaco.png?v=1767594350',
   'MA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Morocco.png?v=1767594349',
   'MX' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Mexico.png?v=1767594351',
   'MD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Moldova.png?v=1767594350',
   'MV' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Maldives.png?v=1767594349',
   'NP' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Nepal.png?v=1767594350',
   'NZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/New_Zealand.png?v=1767594349',
   'MK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/North_Macedonia.png?v=1767594349',
   'NO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Norway.png?v=1767597200',
   'NG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Nigeria.png?v=1767594349',
   'OM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Oman.png?v=1767594350',
   'PS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Palestinian_Territories.png?v=1767594349',
   'PH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Philippines.png?v=1767594350',
   'PL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Poland.png?v=1767594349',
   'PY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Paraguay.png?v=1767594350',
   'PT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Portugal.png?v=1767594350',
   'PE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Peru.png?v=1767594350',
   'PA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Panama.png?v=1767597201',
   'PK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Pakistan.png?v=1767594350',
   'ROW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Rest_of_the_World.png?v=1767596095',
   'RO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Romania.png?v=1767596093',
   'RS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Serbia.png?v=1767596094',
   'SG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Singapore.png?v=1767596093',
   'SK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Slovakia.png?v=1767596093',
   'SI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Slovenia.png?v=1767596093',
   'ZA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/South_Africa.png?v=1767596093',
   'ES' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Spain.png?v=1767597202',
   'LK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Sri_Lanka.png?v=1767596094',
   'SE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Sweden.png?v=1767596093',
   'CH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Switzerland.png?v=1767596093',
   'KR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/South_Korea.png?v=1767596093',
   'SC' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Seychelles.png?v=1767596093',
   'SN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Senegal.png?v=1767596092',
   'TW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Taiwan.png?v=1767596093',
   'TH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Thailand.png?v=1767596093',
   'TN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Tunisia.png?v=1767596092',
   'TR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Turkey.png?v=1767597201',
   'VA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Vatican_City.png?v=1767596094',
   'VN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Vietnam.png?v=1767596093',
   'VE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Venezuela.png?v=1767596093',
   'ZM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Zambia.png?v=1767596094',
   'ZW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Zimbabwe.png?v=1767596094',
    };

  /* Exact URL → Flag map */
  const urlFlags = {
    'https://me.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/UAE.webp?v=1734340288',
    'https://ca.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/ef904a58-fdf0-11ec-85db-525400a0165e.png?v=1657253779',
    'https://eu.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/eu-flag.png?v=1639998050',
    'https://us.manieredevoir.com/': 'https://cdn.shopify.com/s/files/1/1604/7647/files/186-united_states.png?v=1621320141',
    'https://uk.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/1604/7647/files/110-united_kingdom.png?v=1621320141'
    // add remaining URLs here (up to 16)
  };

  const img = document.querySelector('li.country img');
  if (!img) return;

  const countryFlag = window.mdvSelectedCountryForThisStore();

  img.src =
    countryFlags[countryFlag] ||
    urlFlags[location.origin + '/'] ||
    img.src; // fallback = existing flag
}

function setStopRedirect() {
    if (new URLSearchParams(location.search).get('stop_redirect') === 'true') {
        document.cookie = "stop_redirect=true; max-age=" + 7*24*60*60 + "; path=/; domain=.manieredevoir.com; secure";
    }
}

// The prompt used to open only when no country had been chosen at all. But the
// choice is stored domain-wide across all six stores, so a shopper carrying
// another store's country landed in a mismatched context AND was never asked --
// the cookie's presence silently suppressed the prompt. Ask in that case too,
// once per session so a deliberate dismissal sticks for the visit.
function shouldOpenCountrySelector() {
  var stored = getCookie("selectedCountry");
  // Cookieless first visits are handled by mdvMaybeGeoOpen_, which prompts ONLY
  // on a genuine store mismatch. Returning true here is what made this modal fire
  // for every new visitor regardless of whether they were already in the right place.
  if (!stored) return false;
  // If this host isn't represented in the selector we can't tell which market
  // it is, and every stored country would look foreign. Stay quiet rather than
  // prompt shoppers who are already in the right place.
  if (!document.querySelector('.country-selector-select .country-selector-option li[data-href="' + location.origin + '"]')) return false;
  // A stored choice this store actually serves is honoured silently.
  if (typeof window.mdvSelectedCountryForThisStore !== 'function') return false;
  if (window.mdvSelectedCountryForThisStore()) return false;
  // stop_redirect is the QA/dev escape hatch; it suppresses this too.
  if (getCookie("stop_redirect")) return false;
  // They already declined this exact mismatch recently. Keyed to the country so
  // a NEW unserved country asks again, and host-only so declining on one store
  // doesn't silence the others.
  if (getCookie("mdvMismatchDismissed") === stored) return false;
  try {
    if (sessionStorage.getItem('mdvCountryMismatchPrompted') === '1') return false;
    sessionStorage.setItem('mdvCountryMismatchPrompted', '1');
  } catch (_) {
    return false; // storage blocked (private mode) -- stay quiet rather than nag every page
  }
  return true;
}

// The page-load reconcile (syncCurrencySelectorToActive, the last call in
// runCountryFunctions) overwrites the country-derived currency with Shopify's
// active one, so an auto-opened prompt can show "United States of America"
// beside "GBP". Re-apply the currency for the country actually selected,
// immediately before showing the modal. Named so every open path can share it.
// Which market a country belongs to, read from the selector's own markup.
function mdvMarketForCountry_(code) {
    var li = document.querySelector('.country-selector-select .country-selector-option li[data-code="' + code + '"]');
    return li ? li.getAttribute('data-currency') : null;
}
// Which market THIS storefront is, matched on origin so alias hosts resolve correctly.
function mdvCurrentMarket_() {
    var li = document.querySelector('.country-selector-select .country-selector-option li[data-href="' + location.origin + '"]');
    return li ? li.getAttribute('data-currency') : null;
}
// Prompt a cookieless first-time visitor ONLY when their detected country belongs
// to a different STORE (market-level, not country-level: a UK customer browsing
// from Spain is not prompted). Opens when geo resolves, with a 1500ms floor from
// navigation so it never lands on a half-painted page, and a 5000ms cutoff after
// which we stay quiet rather than interrupt someone already reading. The session
// flag is deliberately NOT set on the cutoff path, so the next page may still ask.
function mdvMaybeGeoOpen_(detectedRaw) {
    try {
        var detected = String(detectedRaw || '').toUpperCase();
        if (!/^[A-Z]{2}$/.test(detected)) return;
        if (getCookie('selectedCountry')) return;
        if (getCookie('stop_redirect')) return;
        if (navigator && navigator.webdriver) return;
        var here = mdvCurrentMarket_();
        var there = mdvMarketForCountry_(detected);
        if (!here || !there || here === there) return;
        if (getCookie('mdvGeoDismissed') === detected) return;
        try {
            if (sessionStorage.getItem('mdvGeoPrompted') === '1') return;
        } catch (mdvGeoStorageError) { return; }
        var elapsed = (window.performance && performance.now) ? performance.now() : 1500;
        if (elapsed > 5000) return;
        setTimeout(function mdvGeoOpen() {
            try {
                if ($('.country-selector.custom-country-selector').hasClass('active')) return;
                try { sessionStorage.setItem('mdvGeoPrompted', '1'); } catch (mdvGeoSetError) {}
                mdvPrefillCurrencyForSelectedCountry_();
                window.mdvGeoPromptOpen = detected;
                $('.country-selector.custom-country-selector').addClass('active');
                $('body').addClass('no-scroll');
            } catch (mdvGeoOpenError) {}
        }, Math.max(0, 1500 - elapsed));
    } catch (mdvGeoError) {}
}
function mdvPrefillCurrencyForSelectedCountry_() {
    try {
        var mdvOpenCountry = $('.country-selector-select .country-selector-option li.active').attr('data-code');
        if (mdvOpenCountry) getCurrencyByCountryCode(mdvOpenCountry);
    } catch (mdvPrefillError) {}
}

function openCountrySelectorPopup() {
    setTimeout(function () {
            if (shouldOpenCountrySelector()) {
                // Only a prompt WE raised should be snoozable on dismissal --
                // not the selector opened deliberately from the header.
                window.mdvMismatchPromptOpen = Boolean(getCookie("selectedCountry"));
                mdvPrefillCurrencyForSelectedCountry_();
                $('.country-selector.custom-country-selector').addClass('active');
                $('body').addClass('no-scroll');
            }
    }, 4000);
}

// Currency the shopper choosing countryCode is actually charged in. Same
// authority order as getCurrencyByCountryCode: Shopify Markets map first,
// global hardcoded array second. Null = unknown (caller must fail open).
function mdvChargeCurrencyForCountry_(countryCode) {
    try {
        var mdvMap = window.mdvMarketCurrencies;
        if (mdvMap && typeof mdvMap[countryCode] === 'string' && /^[A-Z]{3}$/.test(mdvMap[countryCode])) {
            return mdvMap[countryCode];
        }
        for (var mdvI = 0; mdvI < countryCurrencyArray.length; mdvI++) {
            if (Object.keys(countryCurrencyArray[mdvI])[0] === countryCode) {
                return countryCurrencyArray[mdvI][countryCode].currency;
            }
        }
    } catch (mdvChargeCcyError) {}
    return null;
}
// Currency an offer line quotes, or null for currency-neutral lines. Explicit
// ISO code beats symbol. Covers every notation in countryOffers today; any
// unrecognised notation returns null, which fails open (line is shown).
function mdvOfferLineCurrency_(offerText) {
    var mdvCode = String(offerText).match(/\b(AUD|AED|CAD|USD|GBP|EUR)\b/);
    if (mdvCode) return mdvCode[1];
    if (offerText.indexOf('\u00A3') !== -1) return 'GBP';
    if (offerText.indexOf('\u20AC') !== -1) return 'EUR';
    if (offerText.indexOf('$') !== -1) return 'USD';
    return null;
}

function getActiveCountryOffers(countryCode) {
    const offersToShow = countryOffers.find(countryOffer => 
        countryOffer.countryCodes.includes(countryCode) || countryOffer.countryCodes.includes("ALL")
    );
    const offers = offersToShow ? offersToShow.offers : [];
    // Drop only lines quoting a currency the shopper is NOT charged in (e.g.
    // "400 AUD" copy for AED countries). Neutral lines stay, so no group can
    // empty (every group has at least one). Unknown charge currency, unknown
    // notation, or any error = show today's copy unchanged.
    var offersFiltered = offers;
    try {
        var mdvChargeCcy = mdvChargeCurrencyForCountry_(countryCode);
        if (mdvChargeCcy) {
            offersFiltered = offers.filter(function (mdvLine) {
                var mdvLineCcy = mdvOfferLineCurrency_(mdvLine);
                return !mdvLineCcy || mdvLineCcy === mdvChargeCcy;
            });
        }
    } catch (mdvOfferFilterError) { offersFiltered = offers; }
    let htmlContent = '<ul>';
    offersFiltered.forEach(offerText => {
        htmlContent += `<li><span class="text-unset">${offerText}</span></li>`;
    });
    htmlContent += '</ul>';
    $(".country-selector-offer").html(htmlContent);
}

function getLanguagesByCountryCode(countryCode) {
    $('.language-select ul.language-select-option li').removeClass("active");
    console.log("countryCodecountryCodecountryCode", countryCode)
    const country = countriesLanguages.find(c => c.country_code.includes(countryCode));
    $(".language-select-option li").hide();
    if (country) {
        country.languages.forEach((language, index) => {
            const languageSelector = `.language-select-option li[value="${language.code}"]`;
            $(languageSelector).show();
            if (index === 0) {
            $(languageSelector).addClass('active');
            $(".language-select-value").html(language.name);
            }
        });
        $(".country-col.language").show();
    } else {
        $(".country-col.language").hide();
    }
}

function getCurrencyByCountryCode(countryCode, hideDropdown) {
    $('.price-select .small li').removeClass('active').hide();

    const result = countryCurrencyArray.filter(item => {
        const country = Object.keys(item)[0];
        return country === countryCode;
    });
    var currencyShow = $('.country-selector-select .country-selector-option li[data-code="' + countryCode + '"]').attr('data-currency');
    let setdefaultCurrency = false;

    // Shopify Markets is the authority on which currency a country is priced in.
    // window.mdvMarketCurrencies comes from localization.available_countries (store
    // config, CDN-cache-safe). The hardcoded countryCurrencyArray is a stale GLOBAL
    // list shared by all six stores: on THIS store it disagreed with Shopify for 40
    // of 63 countries (it promised JPY/INR/SGD/SAR/QAR etc. while Shopify prices
    // every ME country in AED), so it is now only a fallback.
    var mdvResolvedCurrency = null;
    try {
        var mdvCcyMap = window.mdvMarketCurrencies;
        if (mdvCcyMap && typeof mdvCcyMap[countryCode] === 'string' && /^[A-Z]{3}$/.test(mdvCcyMap[countryCode])) {
            mdvResolvedCurrency = mdvCcyMap[countryCode];
        }
    } catch (mdvCcyMapError) {}
    if (!mdvResolvedCurrency && result.length > 0) {
        mdvResolvedCurrency = result[0][countryCode].currency;
    }

    if (mdvResolvedCurrency) {
        // Legacy cookieCurrency branch preserved verbatim below; note it was already
        // dead (computed into `currency`, which the element lookup never used).
        const currency = `${typeof cookieCurrency !== 'undefined' && cookieCurrency ? cookieCurrency : mdvResolvedCurrency }`;
        // Guarded: Shopify enumerates countries the hardcoded array does not.
        const countryName = result.length > 0 ? result[0][countryCode].country : '';
        const currencyElement = $(`.price-select .small li[value="${mdvResolvedCurrency}"]`);
        console.log("1111111111111111",countryCode);
        if (currencyElement.length) {
            currencyElement.addClass('active');
            $('.price-select-value').html(currencyElement.html());
            // Made changes 05-11-2025 Reagarding currency Picker
            $(".currency-picker").val(mdvResolvedCurrency).change();
            console.log("111111111111111122222222222",countryCode);

        } else {
            setdefaultCurrency = true;
        }
    } else {
        setdefaultCurrency = true;
    }
    if (setdefaultCurrency === true && currencyShow === "ME") {
        $('li[value="AED"]').addClass('active');
        $('.price-select-value').html($('li[value="AED"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "UK") {
        $('li[value="GBP"]').addClass('active');
        $('.price-select-value').html($('li[value="GBP"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "US") {
        $('li[value="USD"]').addClass('active');
        $('.price-select-value').html($('li[value="USD"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "EU") {
        $('li[value="EUR"]').addClass('active');
        $('.price-select-value').html($('li[value="EUR"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "CA") {
        $('li[value="CAD"]').addClass('active');
        $('.price-select-value').html($('li[value="CAD"]').html());
    }

    $('.price-select .small li[data-code="' + currencyShow + '"]').show();

    // Hide any currency group header that has no visible items, and restore it
    // when it does. Single-currency markets (US/EU/AU/CA) otherwise render a
    // dangling empty heading. Uses setProperty(...,'important') because the
    // snippet forces span.option-label{display:block!important}, which a plain
    // inline style cannot override. Wrapped defensively: this runs before
    // setActiveCoutry/getLanguagesByCountryCode in the same handler chain.
    try {
        var mdvCcyList = document.querySelector('.price-select ul.small');
        if (mdvCcyList) {
            var mdvHeader = null;
            var mdvShown = 0;
            var mdvApply = function (header, shown) {
                if (!header) return;
                if (shown === 0) header.style.setProperty('display', 'none', 'important');
                else header.style.removeProperty('display');
            };
            for (var mdvI = 0; mdvI < mdvCcyList.children.length; mdvI++) {
                var mdvNode = mdvCcyList.children[mdvI];
                if (mdvNode.classList && mdvNode.classList.contains('option-label')) {
                    mdvApply(mdvHeader, mdvShown);
                    mdvHeader = mdvNode;
                    mdvShown = 0;
                } else if (mdvNode.tagName === 'LI' && mdvNode.style.display !== 'none') {
                    mdvShown++;
                }
            }
            mdvApply(mdvHeader, mdvShown);
        }
    } catch (mdvHeaderErr) {}

}

function setActiveCoutry(ShopifyCountry) {
    $('.custom-country-selector .country-selector-select li[data-code="' + ShopifyCountry + '"]').addClass('active');
    $('.country-selector-zone').val(
        $('.custom-country-selector .country-selector-select li[data-code="' + ShopifyCountry + '"]').html()
    );

    var autoHref = $('.country-selector-select .country-selector-option li.active').attr('data-href');
    if ($('.country-col.language').is(':visible')) {
        languageValue = "?"+$('.language-select-option li.active').attr('value')+"&";
    } else {
        var languageValue = '';
    }
    
    // alert('New URL 1=  '+ autoHref + languageValue);

    if (getCookie('selectedCountry')) {
        if (autoHref !== window.location.origin && !getCookie('stop_redirect')) {
            if (autoHref) {
                var redirection_url;
                try {
                    if (!window.MDVMarketRedirect) throw new Error('MDVMarketRedirect unavailable');
                    redirection_url = window.MDVMarketRedirect.buildMarketRedirectUrl(autoHref, window.location.href, languageValue);
                } catch (mdvRedirectError) {
                    redirection_url = autoHref + window.location.pathname + languageValue;
                }
                // window.location.href = redirection_url;
            } else {
                $('.country-selector-btn .country-selector-error').show();
            }
        }
    }
}

function updateCurrency(newCurrency) {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    updates: cart.items.reduce((acc, item) => {
                        acc[item.id] = item.quantity;
                        return acc;
                    }, {}),
                    currency: newCurrency
                }),
            })
            .then(response => response.json())
            .then(updatedCart => {
                // Made changes 05-11-2025 Reagarding currency Picker
                // document.cookie = "currency=; path=/; domain=.manieredevoir.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure";

                // location.reload();
            })
            .catch(error => console.error('Error updating cart:', error));
        })
        .catch(error => console.error('Error fetching cart:', error));
}

// Example of how to call the function to update the currency
 // Use the desired currency code, like 'USD', 'GBP', 'EUR'

// Reconcile the visible currency label to Shopify's actual resolved active
// currency on page load. getCurrencyByCountryCode() derives the label from a
// *country* source (the selectedCountry cookie, or the IP-detected browsing
// context) which can disagree with the storefront currency Shopify actually
// resolved for the session -- e.g. the selector showed "USD $" while
// Shopify.currency.active (and the cart_currency cookie) were "GBP". This makes
// the server-resolved active currency the last word at init. It is invoked only
// from runCountryFunctions (page-load init), never from the in-modal country
// click handler, so the modal's normal country/currency preview flow is
// preserved exactly.
function syncCurrencySelectorToActive() {
    if (!(window.Shopify && Shopify.currency && Shopify.currency.active)) return;
    var activeCurrency = Shopify.currency.active;
    var activeEl = $('.price-select .small li[value="' + activeCurrency + '"]').first();
    if (!activeEl.length) return; // active currency not in the list -> leave country-derived label untouched
    $('.price-select .small li').removeClass('active');
    activeEl.addClass('active').show();
    $('.price-select-value').html(activeEl.html());
}

function runCountryFunctions(customerTargetCountry){
    setStopRedirect();
    getActiveCountryOffers(customerTargetCountry);
    getCurrencyByCountryCode(customerTargetCountry, true);
    setActiveCoutry(customerTargetCountry);
    getLanguagesByCountryCode(customerTargetCountry);
    // openCountrySelectorPopup();
    // Don't repaint the label while an auto-opened prompt is on screen -- that is
    // what produced the "Ship to USA / currency GBP" contradiction.
    if (!$('.country-selector.custom-country-selector').hasClass('active')) {
        syncCurrencySelectorToActive();
    }
}


$(document).ready(function() {
    if (!getCookie('stop_redirect')) {
        updateCountryFlag();
    }

//    if(getCookie('selectedCountry')){
//         var customerTargetCountry = getCookie('selectedCountry');
//         runCountryFunctions(customerTargetCountry);
//     }else{
//         fetch('/browsing_context_suggestions.json')
//         .then(r => r.json())
//         .then(d => {
//             var customerTargetCountry = d.detected_values.country.handle;
//             runCountryFunctions(customerTargetCountry);
//         });
//     }

    // Get country from URL
    const urlParams = new URLSearchParams(window.location.search);
    let urlCountry = urlParams.get('country');

    if (urlCountry) {
       urlCountry = urlCountry.toUpperCase();
        runCountryFunctions(urlCountry);
        document.cookie = "selectedCountry=" + urlCountry + "; expires=" + new Date(Date.now() + 365*24*60*60*1000).toUTCString() + "; path=/; domain=.manieredevoir.com; secure";
    } else if (getCookie('selectedCountry')) {
        var customerTargetCountry = getCookie('selectedCountry');
        runCountryFunctions(customerTargetCountry);
    } else {
        fetch('/browsing_context_suggestions.json')
        .then(r => r.json())
        .then(d => {
            var customerTargetCountry = d.detected_values.country.handle;
            runCountryFunctions(customerTargetCountry);
            mdvMaybeGeoOpen_(customerTargetCountry);
        })
        .catch(function mdvGeoFetchFailed() {});
    }
    openCountrySelectorPopup();

    if(getCookie('customCurrency')){
        updateCurrency(getCookie('customCurrency'));
    }

    // open popup
    $(document).on("click",'.header-style-one ul.header-right-icon li.country, .pass-right-icon',function(event) {
        event.preventDefault();
        $('.country-selector.custom-country-selector').addClass('active');
        $('body').addClass('no-scroll');
    });
    // close popup
    $(".custom-country-selector .country-selector-close, .country-selector .main-overlay").on("click", function () {
        $(".custom-country-selector.country-selector").removeClass("active");
        $('body').removeClass('no-scroll');
        setCookie("show_redirection", true, '365');
        // Declining a mismatch prompt snoozes it for 30 days for that country.
        // Long enough not to nag a deliberate cross-shopper every visit, short
        // enough that someone stranded by accident gets asked again.
        if (window.mdvMismatchPromptOpen) {
            var dismissed = getCookie("selectedCountry");
            if (dismissed) setCookie("mdvMismatchDismissed", dismissed, '30');
            window.mdvMismatchPromptOpen = false;
        }
        // Declining the geo prompt snoozes it for 30 days for that country, so a
        // deliberate cross-border shopper is not nagged every visit.
        if (window.mdvGeoPromptOpen) {
            setCookie("mdvGeoDismissed", window.mdvGeoPromptOpen, '30');
            window.mdvGeoPromptOpen = false;
        }
        // Shopper stayed rather than switching: put the label back to the currency
        // Shopify is actually charging, so it never contradicts the live prices.
        // Label/li only -- must NOT touch ME's .currency-picker, which would
        // re-convert every visible price mid-session.
        try { if (typeof syncCurrencySelectorToActive === 'function') syncCurrencySelectorToActive(); } catch (mdvSyncError) {}
    });
    // toggle country list
    $(".country-selector-select-arrow").click(function(){
        $(".country-selector-select").toggleClass("active");
        $(".country-selector-option ").toggleClass("active");
    });
    // toggle price
    $(".price-select-arrow").click(function(){
        $(".price-select").toggleClass("active");
        $(".price-select .small").toggleClass("active");
    });
    // toggle language
    $(".language-select-arrow").click(function(){
        $(".language-select").toggleClass("active");
        $(".language-select-option").toggleClass("active");
    });
    // search country 
    $('.country-selector-zone').on("keyup", function () {
        var current_search = $(this).val().toLowerCase();
        $("ul.country-selector-option li").show();
        $("ul.country-selector-option li").each(function (index) {
            var search_match = $(this).attr("value").toLowerCase();
            if (search_match.indexOf(current_search) == 0) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        if ($(this).val().length >= 1) {
            $('.country-selector-option .option-label').hide();
        } else {
            $(".country-selector-option .option-label").show();
        }
    });
    // open price list
    $('.price-select-value').on("click", function () {
        $(this).next(".price-select .small").addClass("active");
        $(this).parents('.price-select').addClass("active");
    });
    // Made changes 05-11-2025 Reagarding currency Picker
    //Add price list selected option
    $('.price-select li').on("click", function () {
        console.log("55555555555",$(this).attr("value"));
        var currencyData = $(this).attr("value");
        $(".currency-picker").val(currencyData).change();
    });
    // select price li
    $('.custom-country-selector .country-selector-form .price-select li').on("click", function () {
        $('.custom-country-selector .country-selector-form .price-select li').removeClass('active');
        $(this).addClass('active');
        $('.custom-country-selector .country-selector-form .price-select-value').html($('.custom-country-selector .country-selector-form .price-select li[value=' + $(this).attr("value") + ']').html());
        $(this).parents("ul.small").removeClass('active');
        $(this).parents('.price-select').removeClass("active");
    });
    // select country li
    $('.custom-country-selector .country-selector-select li').on("click", function () {
        $('.custom-country-selector .country-selector-select li').removeClass("active");
        $(this).addClass("active");
        $('.country-selector-zone').val($(this).attr("value"));
        getActiveCountryOffers($(this).attr("data-code"));
        console.log("fdffghfgh", $(this).attr("data-code"))
        getCurrencyByCountryCode($(this).attr("data-code"));
        getLanguagesByCountryCode($(this).attr("data-code"));
        $(this).parents("ul").removeClass("active");
    });
    // open country list
    $('.country-selector-zone').on("click", function () {
        $(this).next("ul.country-selector-option").addClass("active");
        $(this).parents('.country-selector-select').addClass("active");
    });
    // clear on focus so typing filters from scratch; restore on blur if the
    // shopper picked nothing. Restore source is li.active (single source of
    // truth). Value+placeholder+alignment only: never changes country, never
    // opens or closes anything. Restore-if-empty + the li click handler's
    // unconditional .val() write makes blur/click ordering irrelevant.
    $('.country-selector-zone').on("focus", function () {
        $(this).attr("placeholder", "Search Country").css("text-align", "center").val("").trigger("keyup");
    });
    $('.country-selector-zone').on("blur", function () {
        $(this).attr("placeholder", "Select Country").css("text-align", "");
        if ($(this).val() !== "") return;
        var activeCountryName = $('.custom-country-selector .country-selector-select li.active').attr("value");
        if (activeCountryName) $(this).val(activeCountryName);
    });
    // open language list
    $('.language-select-value').on("click", function () {
        $(this).next("ul.language-select-option").addClass("active");
        $(this).parents('.language-select').addClass("active");
    });
    // select language li
    $('.language-select ul.language-select-option li').on("click", function () {
        $('.language-select ul.language-select-option li').removeClass("active");
        $(this).addClass("active");
        $(this).parents(".language-select").find(".language-select-value").html($(this).html());
        $(this).parents("ul.language-select-option").removeClass("active");
        $(this).parents('.language-select').removeClass("active");
    });
    // Update Button 
    $(".custom-country-selector button#change_country").on("click", function (event) {
        event.preventDefault();

        var dataHref = $('.country-selector-select .country-selector-option li.active').attr('data-href');
        var selectedPrice = $('.price-select .small li.active').attr('value');
        var selectedCountry = $('.country-selector-select .country-selector-option li.active').attr('data-code')
        if ($('.country-col.language').is(':visible')) {
            var languageValue = "?"+$('.language-select-option li.active').attr('value')+"&";
        } else {
            var languageValue = '';
        }
        if (dataHref) {
            setCookie("show_redirection", true, '365');
            var redirection_url;
            try {
                if (!window.MDVMarketRedirect) throw new Error('MDVMarketRedirect unavailable');
                redirection_url = window.MDVMarketRedirect.buildMarketRedirectUrl(dataHref, window.location.href, languageValue, selectedPrice);
            } catch (mdvRedirectError) {
                redirection_url = dataHref + window.location.pathname + languageValue;
            }
            document.cookie = "customCurrency=" + selectedPrice + "; path=/; domain=.manieredevoir.com; secure";
            document.cookie = "selectedCountry=" + selectedCountry + "; expires=" + new Date(Date.now() + 365*24*60*60*1000).toUTCString() + "; path=/; domain=.manieredevoir.com; secure";
            
            // alert('New URL =  '+ redirection_url);

            // setTimeout(function() {
                window.location.href = redirection_url;
            // }, 1000);
            
        } else {
            $('.country-selector-btn .country-selector-error').show();
        }

    });
});


// close all list
$(document).on('click', function (event) {
    if (!$(event.target).closest('.price-select').length) {
        $(".price-select .small").removeClass("active");
        $('.price-select').removeClass("active");
    }
    if (!$(event.target).closest('.country-selector-select').length) {
        $(".country-selector-select").removeClass("active");
        $(".country-selector-option ").removeClass("active");
    }
    if (!$(event.target).closest('.language-select').length) {
        $(".language-select").removeClass("active");
        $(".language-select-option").removeClass("active");
    }
});

